import { render, staticRenderFns } from "./SMANgbTeamMembersList.vue?vue&type=template&id=fa95c7ec"
import script from "./SMANgbTeamMembersList.vue?vue&type=script&lang=js"
export * from "./SMANgbTeamMembersList.vue?vue&type=script&lang=js"
import style0 from "./SMANgbTeamMembersList.vue?vue&type=style&index=0&id=fa95c7ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports